export const textToolTip = {
  color: "white",
  border: "solid 1px",
  borderColor: "black",
  borderRadius: "8px",
  overflow: "hidden",
  backgroundColor: "black",
  maxWidth: "200px",
  padding: "20px",
};
